export const DoorSystemKeys = {
  relayControlDoorsLoopSka1: 'relayControlDoorsLoopSka1',
  relayControlDoorsLoopSka2: 'relayControlDoorsLoopSka2',
  slDoorControlByPassSka1: 'slDoorControlByPassSka1',
  slDoorControlByPassSka2: 'slDoorControlByPassSka2',
  internalDoorLevel2Error: 'internalDoorLevel2Error',
  isOuterDoor1OutOfService: 'isOuterDoor1OutOfService',
  isOuterDoor2OutOfService: 'isOuterDoor2OutOfService',
  isOuterDoor3OutOfService: 'isOuterDoor3OutOfService',
  isOuterDoor4OutOfService: 'isOuterDoor4OutOfService',
  isOuterDoor1MajorError: 'isOuterDoor1MajorError',
  isOuterDoor2MajorError: 'isOuterDoor2MajorError',
  isOuterDoor3MajorError: 'isOuterDoor3MajorError',
  isOuterDoor4MajorError: 'isOuterDoor4MajorError',
  isOuterDoor1MinorError: 'isOuterDoor1MinorError',
  isOuterDoor2MinorError: 'isOuterDoor2MinorError',
  isOuterDoor3MinorError: 'isOuterDoor3MinorError',
  isOuterDoor4MinorError: 'isOuterDoor4MinorError',
  isOuterDoor1FullyOpen: 'isOuterDoor1FullyOpen',
  isOuterDoor2FullyOpen: 'isOuterDoor2FullyOpen',
  isOuterDoor3FullyOpen: 'isOuterDoor3FullyOpen',
  isOuterDoor4FullyOpen: 'isOuterDoor4FullyOpen',
  isOuterDoor1Enabled: 'isOuterDoor1Enabled',
  isOuterDoor2Enabled: 'isOuterDoor2Enabled',
  isOuterDoor3Enabled: 'isOuterDoor3Enabled',
  isOuterDoor4Enabled: 'isOuterDoor4Enabled',
  isOuterDoor1ClosedAndLocked: 'isOuterDoor1ClosedAndLocked',
  isOuterDoor2ClosedAndLocked: 'isOuterDoor2ClosedAndLocked',
  isOuterDoor3ClosedAndLocked: 'isOuterDoor3ClosedAndLocked',
  isOuterDoor4ClosedAndLocked: 'isOuterDoor4ClosedAndLocked',
  isEndDoor1LockedCloseAndLockedOpen: 'isEndDoor1LockedCloseAndLockedOpen',
  isEndDoor2LockedCloseAndLockedOpen: 'isEndDoor2LockedCloseAndLockedOpen',
  isInnerDoor1LockedCloseAndLockedOpen: 'isInnerDoor1LockedCloseAndLockedOpen',
  isInnerDoor2LockedCloseAndLockedOpen: 'isInnerDoor2LockedCloseAndLockedOpen',
  isBistroDoorLockedCloseAndLockedOpen: 'isBistroDoorLockedCloseAndLockedOpen',
  isPRMDoor1Active: 'isPRMDoor1Active',
  isPRMDoor2Active: 'isPRMDoor2Active',
  outerDoor1IsObstructed: 'outerDoor1IsObstructed',
  outerDoor2IsObstructed: 'outerDoor2IsObstructed',
  outerDoor3IsObstructed: 'outerDoor3IsObstructed',
  outerDoor4IsObstructed: 'outerDoor4IsObstructed',
  isOuterDoor1CommunicationError: 'isOuterDoor1CommunicationError',
  isOuterDoor2CommunicationError: 'isOuterDoor2CommunicationError',
  isOuterDoor3CommunicationError: 'isOuterDoor3CommunicationError',
  isOuterDoor4CommunicationError: 'isOuterDoor4CommunicationError',
  isEndDoor1MinorError: 'isEndDoor1MinorError',
  isEndDoor2MinorError: 'isEndDoor2MinorError',
  isInnerDoor1MinorError: 'isInnerDoor1MinorError',
  isInnerDoor2MinorError: 'isInnerDoor2MinorError',
  isBistroDoorMinorError: 'isBistroDoorMinorError',
  isEndDoor1MajorError: 'isEndDoor1MajorError',
  isEndDoor2MajorError: 'isEndDoor2MajorError',
  isInnerDoor1MajorError: 'isInnerDoor1MajorError',
  isInnerDoor2MajorError: 'isInnerDoor2MajorError',
  isBistroDoorMajorError: 'isBistroDoorMajorError',
  isEndDoor1CommunicationError: 'isEndDoor1CommunicationError',
  isEndDoor2CommunicationError: 'isEndDoor2CommunicationError',
  isInnerDoor1CommunicationError: 'isInnerDoor1CommunicationError',
  isInnerDoor2CommunicationError: 'isInnerDoor2CommunicationError',
  isBistroDoorCommunicationError: 'isBistroDoorCommunicationError'
} as const;
